var React = require('react');

function HangupInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"24","fill":"#E87D7D","key":0}),React.createElement("path",{"d":"M35.8428 20.3867C32.7294 18.281 28.8789 18.165 28.8789 18.165H19.1289C19.1289 18.165 15.2784 18.281 12.1649 20.3867C10.1366 21.7578 9 24.1186 9 26.5671C9 27.8197 10.0155 28.8351 11.268 28.8351H13.6856C15.6753 28.8351 17.4459 27.5748 18.1005 25.696C18.4175 24.7836 19.2809 24.1753 20.2474 24.1831L23.1186 24.2063V24.2217L24 24.214L24.8814 24.2217V24.2063L27.7526 24.1831C28.7191 24.1753 29.5825 24.7836 29.8995 25.696C30.5515 27.5748 32.3247 28.8351 34.3144 28.8351H36.732C37.9845 28.8351 39 27.8197 39 26.5671C39 24.1186 37.8634 21.7604 35.8351 20.3867H35.8428Z","fill":"white","key":1})]);
}

HangupInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = HangupInline;

HangupInline.default = HangupInline;
